module.exports = __webpack_public_path__ + "static/helmet-d1535ecb1e374254fdfd410a36b5264d.svg";